export default "__VITE_ASSET__f0a06ab4__"